import React from 'react';
import { connect } from 'react-redux';
import { updateMeetingRoom, resetMeetingRoomForm } from '../../../../actions/meetingRoom';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowUpdateMeetingRoomModal } from '../../../../actions/modal';

@connect()
export default class RightPanelUpdate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      meetingRoomForm: props.meetingRoomForm,
    };
    this.resetForm = this.resetForm.bind(this);
    this.updateMeetingRoom = this.updateMeetingRoom.bind(this);
    this.cancelUpdateMeetingRoom = this.cancelUpdateMeetingRoom.bind(this);
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA

    this.setState({ meetingRoomForm: props.meetingRoomForm });
  }
  updateMeetingRoom(e) {
    let areThereErrors = forceValidation(undefined, undefined, 'updateMeetingRoomForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      console.log(!areThereErrors && !window.$(e.target).hasClass('disable'));
      let cb = () => {
        let show = false;
        this.props.dispatch(updateShowUpdateMeetingRoomModal(show));
        this.resetForm();
      };
      this.props.dispatch(updateMeetingRoom(this.state.meetingRoomForm, cb));
    } else {
    }
  }
  componentWillUnmount() {}

  cancelUpdateMeetingRoom() {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    let show = false;
    this.props.dispatch(updateShowUpdateMeetingRoomModal(show));
    this.resetForm();
  }

  resetForm() {
    //TODO : Here we are clearing the dropdown, verify if we still want that window.$('.meeting-room-create-update .ui.dropdown').dropdown('clear')
    this.props.dispatch(resetMeetingRoomForm());
  }

  render() {
    let saveClasses =
      'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
    return (
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="2"
          type="button"
          onClick={this.updateMeetingRoom}
          data-group="updateMeetingRoomForm"
          className={this.state.meetingRoomForm.fetching ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save} <i className="save  icon" />
        </button>
        <button
          tabIndex="3"
          type="button"
          onClick={this.cancelUpdateMeetingRoom}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}
